import * as actionTypes from "./ReportsType";

const INITIAL_STATE = {
  reportParam: [],
};

const ReportsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SETREPORTPARAM:
      return {
        ...state,
        reportParam: action.payload,
      };
    default:
      return state;
  }
};

export default ReportsReducer;
